<div
  class="container"
  [class.rtl]="layoutService.websiteDirection$.value === 'rtl'"
>
  <!-- start snack bar info  -->
  <div class="info">
    <mat-icon class="icon">{{ data?.icon }}</mat-icon>
    <!-- start message -->
    <div class="flex column justify-flex-start align-items-start">
      <span>{{ data?.message }}</span>
      <a target="_blank" *ngIf="data?.url" [href]="data?.url">{{
        data?.urlText ? data?.urlText : data?.url
      }}</a>
    </div>
    <!-- end message -->
  </div>
  <!-- end snack bar info  -->
  <!-- --------------------------  -->
  <!-- start close snack bar button  -->
  <div class="close-button">
    <mat-icon class="icon" (click)="snackBarRef.dismiss()">close</mat-icon>
  </div>
  <!-- end close snack bar button  -->
</div>
